import { render, staticRenderFns } from "./TypeGame.vue?vue&type=template&id=378e3d38&scoped=true"
var script = {}
import style0 from "./TypeGame.vue?vue&type=style&index=0&id=378e3d38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "378e3d38",
  null
  
)

export default component.exports